var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 11.25H15.5V33.768H30.5V11.25ZM32.375 11.25V33.768H35.1875C36.7408 33.768 38 32.5088 38 30.9555V14.0625C38 12.5092 36.7408 11.25 35.1875 11.25H32.375ZM13.625 11.25H10.8125C9.2592 11.25 8 12.5092 8 14.0625V30.9555C8 32.5088 9.2592 33.768 10.8125 33.768H13.625V11.25ZM17.375 9.375V8.4375C17.375 6.8842 18.6342 5.625 20.1875 5.625H25.8125C27.3658 5.625 28.625 6.8842 28.625 8.4375V9.375H35.1875C37.7763 9.375 39.875 11.4737 39.875 14.0625V30.9555C39.875 33.5444 37.7763 35.643 35.1875 35.643H10.8125C8.22367 35.643 6.125 33.5444 6.125 30.9555V14.0625C6.125 11.4737 8.22367 9.375 10.8125 9.375H17.375ZM26.75 9.375V8.4375C26.75 7.91973 26.3303 7.5 25.8125 7.5H20.1875C19.6697 7.5 19.25 7.91973 19.25 8.4375V9.375H26.75Z",
    fill: "#55749F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.9008e3908f888f5151e2272cf336cb11.svg";
export { ForwardRef as ReactComponent };